export default __webpack_public_path__ + "static/media/Taskmo-Brand-Logos.de0b0323.zip";